import "./App.css";
import React from "react";
import { StarekContextProvider } from "./context/StarekContext";
import StarekApp from "./StarekApp";
import { useVersionCheck } from "./hooks/useVersionCheck";
import NewVersionDialog from "./components/NewVersionDialog";

function App() {
    const newVersion = useVersionCheck();

    return (
        <StarekContextProvider>
            <StarekApp></StarekApp>
            <NewVersionDialog version={newVersion}></NewVersionDialog>
        </StarekContextProvider>
    );
}

export default App;
